import config from '@/config';
import api from '@/shared/api';
import { useEffect, useState } from 'react';
const useGetRelation = (relationId) => {
    const [relation, setRelation] = useState();
    useEffect(() => {
        let isMounted = true;
        api.base
            .post(`${config.appUrls.api}/api/relation/Names`, [relationId])
            .then(({ data: [rel] }) => {
            if (rel && isMounted) {
                setRelation(rel);
            }
        });
        return () => {
            isMounted = false;
        };
    }, [relationId]);
    return relation;
};
export default useGetRelation;
